import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-900">This page has not been generated</h1>
        <p className="mt-2 text-base text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-600">Tell me more about this page, so I can generate it</p>
        <a
          href="/"
          className="inline-flex items-center px-5 py-2.5 mt-8 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md transition-colors whitespace-nowrap"
        >
          <i className="ri-home-line mr-2"></i>
          Back to Homepage
        </a>
      </div>
    </div>
  );
}